<vo-vm-theme-provider>
  <div class="vm-container">
    <vo-breadcrumbs>
      <vo-breadcrumb>
        <a vo-anchor vo-text size="T200" vmGtmCta href="https://virginmedia.com" iconOnly>
          <vo-icon icon="Home" />
        </a>
      </vo-breadcrumb>
      <vo-breadcrumb *ngFor="let breadcrumb of breadcrumbs">
        <a vo-anchor vo-text size="T200" (click)="toUrl(breadcrumb?.routerLink)">{{ breadcrumb?.name }}</a>
      </vo-breadcrumb>
    </vo-breadcrumbs>

    <div class="vm-container cozy second-vm-container">
      <div class="margin-top-16" *ngIf="tvErrorCodesMainContent">
        <h1 vo-text [size]="'T600'" [weight]="'medium'">{{ tvErrorCodesMainContent.title }}</h1>
        <div class="margin-top-16">
          <p vo-text [size]="'T300'">{{ tvErrorCodesMainContent?.copy }}</p>
        </div>
      </div>

      <div class="margin-top-32" *ngIf="tvErrorCodesSearchContent">
        <h2 vo-text [size]="'T400'" [weight]="'medium'">{{ tvErrorCodesSearchContent.title }}</h2>

        <div class="tv-error-codes-search-wrapper margin-top-16" [class.hasSearchOverlay]="shouldShowOverlay">
          <!-- todo: use Momentum component when ready to work with Angular CDK -->
          <input
            class="tv-error-codes-search-input"
            [attr.placeholder]="tvErrorCodesSearchContent.subtitle"
            [formControl]="searchCtrl"
            #trigger="cdkOverlayOrigin"
            cdkOverlayOrigin
            (focus)="
              (searchCtrl.value?.length || searchResults.length) && (shouldShowOverlay = true) && (hideOverlay = true)
            " />

          <ng-template
            *ngIf="searchTerm$ | async"
            #overlay="cdkConnectedOverlay"
            cdkConnectedOverlay
            [cdkConnectedOverlayHasBackdrop]="false"
            [cdkConnectedOverlayOrigin]="trigger"
            (backdropClick)="shouldShowOverlay = false"
            [cdkConnectedOverlayOpen]="shouldShowOverlay"
            [cdkConnectedOverlayWidth]="trigger.elementRef.nativeElement.getBoundingClientRect().width"
            (overlayKeydown)="$event.key === 'Escape' && (shouldShowOverlay = false)">
            <div class="tv-error-codes-search-results-wrapper">
              <ul class="tv-error-codes-search-results" *ngIf="searchResults.length; else noResultsTemplate">
                <li vo-text [size]="'T300'" *ngFor="let option of searchResults">
                  <a (click)="errorCodeClick(option.url)">{{ option.label }}</a>
                </li>
              </ul>
            </div>
          </ng-template>
          <ng-template #noResultsTemplate>
            <div
              class="tv-error-codes-not-found"
              *ngIf="tvErrorCodesSearchContent?.listOfContent[0]; let notFoundContent">
              <p vo-text [size]="'T300'">{{ notFoundContent?.text }}</p>
              <p vo-text [size]="'T300'">{{ notFoundContent?.content }}</p>
            </div>
          </ng-template>

          <hr class="margin-top-32" />
          <div class="filter-tiles-container margin-top-32" *ngIf="findYourErrorCode">
            <h2 vo-text [size]="'T400'" [weight]="'medium'">{{ findYourErrorCode?.title }}</h2>
            <div class="margin-top-16">
              <p vo-text [size]="'T300'">{{ findYourErrorCode?.copy }}</p>
            </div>
            <div class="filter-tiles-container__buttons">
              <vo-tabs>
                <vo-tab *ngFor="let tvErrorCode of findYourErrorCode.ctas" [label]="tvErrorCode.label">
                  <div class="vm-row" *ngIf="filterCodes && filterCodes[tvErrorCode?.dataAttrValue]">
                    <ng-container *ngFor="let tve of filterCodes[tvErrorCode?.dataAttrValue]">
                      <div class="vm-col-xs-6 vm-col-md-2" *ngIf="tve?.display">
                        <a vo-tile (click)="toUrl(tve?.url)">
                          {{ tve?.label }}
                        </a>
                      </div>
                    </ng-container>
                  </div>
                </vo-tab>
              </vo-tabs>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</vo-vm-theme-provider>
